import { type FC } from 'react'

import { ProductPicture } from '../../../../product'
import { useProductPageContext } from '../../productPageContext'

import { ProductBuyBoxStickyAddToCart } from './ProductBuyBoxStickyAddToCart'
import { ProductBuyBoxStickyScrollToVariantSelection } from './ProductBuyBoxStickyAddToCart/ProductBuyBoxStickyScrollToVariantSelection'
import { ProductBuyBoxStickyPriceAndPackage } from './ProductBuyBoxStickyPriceAndPackage'

export const ProductBuyBoxSticky: FC = () => {
  const { attributeSelectionControls, isMasterPage, product } =
    useProductPageContext()

  const showScrollToVariantSelection =
    isMasterPage ||
    attributeSelectionControls.attributeNotSelectedErrorControls
      .hasUnselectedAttributes

  return (
    <div className="fixed inset-x-0 bottom-0 z-10 flex items-center gap-2.5 bg-light-primary-low p-3.5 shadow-[0_6px_12px_#00000033] tablet:hidden">
      <ProductPicture
        className="shrink-0"
        imageProps={{
          alt: product.name,
          height: 70,
          src: product.images?.at(0),
          width: 70,
        }}
      />
      {showScrollToVariantSelection ? (
        <ProductBuyBoxStickyScrollToVariantSelection className="grow" />
      ) : (
        <>
          <ProductBuyBoxStickyPriceAndPackage />
          <ProductBuyBoxStickyAddToCart />
        </>
      )}
    </div>
  )
}
